import { render, staticRenderFns } from "./GitInfoPrompt.vue?vue&type=template&id=39890967&scoped=true"
import script from "./GitInfoPrompt.vue?vue&type=script&lang=js"
export * from "./GitInfoPrompt.vue?vue&type=script&lang=js"
import style0 from "./GitInfoPrompt.vue?vue&type=style&index=0&id=39890967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39890967",
  null
  
)

export default component.exports